module.exports = __webpack_public_path__ + "static/media/wateruser-industry.4b0700df.png";